<script lang="ts">
    import { closeModal } from 'svelte-modals';
    import { _ } from 'svelte-i18n';
    import ButtonMain from '../ButtonMain.svelte';
    import { customerSettings } from '../../../stores/api';

    export let isOpen: boolean = false;
    export let text: string = '';
</script>

{#if isOpen}
    <div role="dialog" class="modal">
        <div class="contents">
            <h3>{$_('help_and_support')}</h3>
            <div class="modal-body">
                <div style="opacity: 0.7; text-align: center;">{$_('help_and_support_info')}:</div>
                <div>
                    <a
                        class="upload-link"
                        href="mailto:{$customerSettings.help_and_support.email}?subject={$_(
                            'email_subject'
                        )}">{$customerSettings.help_and_support.email}</a
                    >
                </div>
                <div>
                    <a
                        class="upload-link"
                        href="tel:{$customerSettings.help_and_support.phone.replaceAll(' ', '')}"
                    >
                        {$customerSettings.help_and_support.phone}</a
                    >
                </div>
            </div>

            <div class="actions">
                <ButtonMain
                    text={$_('OK')}
                    on:click={() => {
                        closeModal();
                    }}
                />
            </div>
        </div>
    </div>
{/if}

<style>
    .modal {
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 1002;

        /* allow click-through to backdrop */
        pointer-events: none;
    }

    .modal-body {
        display: flex;
        flex-direction: column;
        align-items: center;
        row-gap: 20px;
    }

    .upload-link {
        color: #1d5fc9;
        text-decoration: none;
        cursor: pointer;
        text-align: center;
    }

    .contents {
        width: 520px;
        border-radius: 6px;
        background: white;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        pointer-events: auto;
        font-size: 14px;
        padding: 30px;
        border: 3px solid var(--automapa-blue);
        box-shadow:
            0 0 0 10px #1c5dc722,
            0 4px 8px rgba(0, 0, 0, 0.2);
    }

    .actions {
        margin-top: 32px;
        display: flex;
        justify-content: center;
        column-gap: 10px;
    }
</style>
